import { createContext, useContext } from 'react';

import { FSetupGraph } from '../../graph/index.js';

export const GraphContext = createContext<FSetupGraph | null>(null);

export const useGraph = () => {
  const graph = useContext(GraphContext);
  if (!graph) {
    throw new Error('useGraph must be used within a GraphProvider');
  }
  return graph;
};
